module.exports = __webpack_public_path__ + "static/media/user-robot.57eb648e.svg";